import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash.isnil';
import { ClassSummaryTitle, ClassSummaryInfo } from './ClassSummaryElements';
import './ClassSummary.scss';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const ClassSummary = ({ infoSummary, totalStudentCount, isSummary, assessedStudents }) => (
    <div className={`${infoSummary.summarySectionClass} ${isSummary && 'summary'}`}>
        <ClassSummaryTitle subHeaderClass={infoSummary.subHeaderClass} />
        {!isNil(infoSummary.skills)
            ? infoSummary.skills.map((skill, index) => (
                  <ClassSummaryInfo
                      key={generateReactKey(index)}
                      showTotalStudentsCount={infoSummary.showTotalStudentsCount}
                      studentsCount={assessedStudents[skill]}
                      totalStudentCount={totalStudentCount}
                      status={infoSummary.status}
                      skill={skill}
                  />
              ))
            : infoSummary.status.map((status, index) => (
                  <ClassSummaryInfo
                      key={generateReactKey(index)}
                      showTotalStudentsCount={!infoSummary.showTotalStudentsCount && index === 0}
                      studentsCount={infoSummary.assessment[status]}
                      totalStudentCount={totalStudentCount}
                      status={status}
                  />
              ))}
    </div>
);

ClassSummary.propTypes = {
    totalStudentCount: PropTypes.number,
    infoSummary: PropTypes.object.isRequired,
    assessedStudents: PropTypes.object,
    isSummary: PropTypes.bool,
};
ClassSummary.defaultProps = {
    totalStudentCount: 0,
    isSummary: false,
    assessedStudents: {},
};
export default ClassSummary;
